import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const statusOpt =
  {
    "NUMBER_GENERATED":"Numeração gerada",
    "DRAFT":"Em preenchimento",
    "APP_DELETED":"Excluído (app)",
    "SYSTEM_DELETED":"Excluído (sistema)",
    "FILE_SENT":"Documento enviado",
    "PENDING":"Pendente (aprovação)",
    "REVIEWED":"Revisado",
    "REJECTED":"Reprovado",
    "APPROVED":"Aprovado",
    "INVALIDATED":"Invalidado"
  }

const reportId = "bo-status";
const BosStatus = ({data, boName}) => {
  const reportName = `Status dos ${boName}`

  useEffect(() => {
    const values = data.map(i => i.qty);
    const labels = data.map(i => statusOpt[i.status] ?? i.status);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default BosStatus;